import React, { useState, createContext, useContext, useEffect } from "react";
import { AdminRoute, VendorRoute } from "./pages/ProtectedRoutes";
import Unauthorized from "./pages/Unauthorized";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import DashboardClientComponent from "./pages/Dashboard";
import SideNavBarClientComponent from "./components/SideNavbar";
import TopNavbar from "./components/TopNavbar";
import CategoryManagement from "./pages/Category";
import CreateProduct from "./pages/CreateProduct";
import UserProfile from "./pages/UserProfile";
import UserManagement from "./pages/Users";
import PurchaseManagement from "./pages/Purchases";
import ProductColorManagement from "./pages/ProductColor";
import ProductMaterialManagement from "./pages/ProductMaterialManagement";
import ProductList from "./pages/ProductList";
import AddPurchase from "./pages/AddPurchase";
import AddSale from "./pages/AddSale";
import SalesManagement from "./pages/Sales";
import AddUser from "./pages/AddUser";
import SalesReport from './pages/SalesReport'
import InventoryReport from './pages/InventoryReport'
import PurchasesReport from './pages/PurchasesReport';
import Inventory from "./pages/Inventory";
import VendorManagement from "./pages/Vendors";
import AllCourierPartner from "./pages/AllCourierPartner";
import AllOrderMedium from "./pages/AllOrderMedium";
import AddOrder from "./pages/AddOrder";
import AllOrder from "./pages/AllOrder";
import EditOrder from "./pages/EditOrder"
import AddItem from "./pages/AddItem"
import AllOrderStatus from "./pages/AllOrderStatus";
import ViewOrder from "./pages/ViewOrder"
import AllVendorProducts from "./pages/AllVendorProducts";
import AllVendorOrder from "./pages/AllVendorOrder";
import VendorDashboard from "./pages/VendorDashboard";
import EditProfile from "./pages/EditProfile"
import ProductStatus from "./pages/ProductStatus"
import ViewVendorOrder from "./pages/ViewVendorOrder";
import AllVendorPayments from "./pages/AllVendorPayments";
import AllPurchaseBillMerchants from "./pages/AllPurchaseBillMerchants";
import AllPurchaseBill from "./pages/AllPurchaseBill";
import AddPurchaseBill from "./pages/AddPurchaseBill";
import AllTransactionsMerchantName from "./pages/AllTransactionsMerchantName";
import AllTransactions from "./pages/AllTransactions";
import AddTransaction from "./pages/AddTransactions";
import AllLeadStatus from "./pages/AllLeadStatus";
import AllLeadType from "./pages/AllLeadType";
import AllLead from "./pages/AllLead";
import AddLead from "./pages/AddLead";
import AllBtobsalesCustomers from "./pages/AllBtobsalesCustomers";
import AddBtobsales from "./pages/AddBtobsales";
import AllBtobsales from "./pages/AllBtobsales";
import AllLeadLookingFor from "./pages/LeadLookingFor";
import LeadComments from "./pages/LeadComments";
const SidebarContext = createContext({ isCollapsed: false, setIsCollapsed: () => { } });
export const useSidebar = () => useContext(SidebarContext);

function ProtectedRoute({ element }) {
  const token = localStorage.getItem("accessToken");

  return token ? element : <Navigate to="/login" replace />;
}





function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isCollapsed, setIsCollapsed } = useSidebar();
  const showNav =
    location.pathname !== "/login" &&
    location.pathname !== "/signup" &&
    location.pathname !== "/verify-otp" &&
    !location.pathname.startsWith("/view-order/") &&
    !location.pathname.startsWith("/vendor-order/");
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsRedirecting(true);
      setTimeout(() => {
        navigate("/login", { replace: true });
        setIsRedirecting(false);
      }, 10); // Tiny delay to prevent UI flash
    }
  }, [location.pathname, navigate]);

  if (isRedirecting) {
    return <div className="w-screen h-screen bg-white"></div>; // White screen while redirecting
  }

  return (
    // <div className={`overflow-y-hidden relative min-h-screen bg-gray-50`}>
    <div
      className={`${location.pathname.startsWith("/view-order/")
          ? "overflow-y-auto"
          : "overflow-y-hidden"
        } relative min-h-screen bg-gray-50`}
    >

      {showNav && (
        <>
          <SideNavBarClientComponent isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
          <TopNavbar />
        </>
      )}
      {/* <div className={`${showNav ? 'ml-64' : 'h-screen overflow-hidden'} p-6 bg-gray-50 transition-all duration-300 ease-in-out`}> */}
      {/* <div
  className={`${
    showNav ? "ml-64" : "min-h-screen overflow-y-auto"
  } p-6 bg-gray-50 transition-all duration-300 ease-in-out`}
> */}
      <div
        className={`
    ${showNav
            ? (isCollapsed ? "ml-16" : "ml-64")
            : "ml-0"
          }
    p-6 bg-gray-50 transition-all duration-300 ease-in-out
    max-[750px]:p-2 
    max-[650px]:ml-12 
    max-[450px]:ml-0
    h-full overflow-y-auto
  `}
      >


        <Routes>

          <Route path="/login" element={<Login />} />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/dashboard" element={<AdminRoute element={<DashboardClientComponent />} />} />
          <Route path="/product-category" element={<AdminRoute element={<CategoryManagement />} />} />
          <Route path="/add-product" element={<AdminRoute element={<CreateProduct />} />} />
          <Route path="/user-profile" element={<AdminRoute element={<UserProfile />} />} />
          <Route path="/add-user" element={<AdminRoute element={<AddUser />} />} />
          <Route path="/all-users" element={<AdminRoute element={<UserManagement />} />} />
          <Route path="/all-vendors" element={<AdminRoute element={<VendorManagement />} />} />
          <Route path="/all-purchases" element={<AdminRoute element={<PurchaseManagement />} />} />
          <Route path="/product-color" element={<AdminRoute element={<ProductColorManagement />} />} />
          <Route path="/product-materials" element={<AdminRoute element={<ProductMaterialManagement />} />} />
          <Route path="/all-products" element={<AdminRoute element={<ProductList />} />} />
          <Route path="/add-purchase" element={<AdminRoute element={<AddPurchase />} />} />
          <Route path="/add-sale" element={<AdminRoute element={<AddSale />} />} />
          <Route path="/all-sales" element={<AdminRoute element={<SalesManagement />} />} />
          <Route path="/sales-report" element={<AdminRoute element={<SalesReport />} />} />
          <Route path="/inventory-report" element={<AdminRoute element={<InventoryReport />} />} />
          <Route path="/purchase-report" element={<AdminRoute element={<PurchasesReport />} />} />
          <Route path="/inventory" element={<AdminRoute element={<Inventory />} />} />
          <Route path="/all-vendor-payments" element={<AdminRoute element={<AllVendorPayments />} />} />
          //added AllOrder
          <Route path="/all-courier-partner" element={<AdminRoute element={<AllCourierPartner />} />} />
          <Route path="/all-order-medium" element={<AdminRoute element={<AllOrderMedium />} />} />
          <Route path="/add-order" element={<AdminRoute element={<AddOrder />} />} />
          <Route path="/all-order" element={<AdminRoute element={<AllOrder />} />} />
          <Route path="/view-order/:orderId" element={<AdminRoute element={<ViewOrder />} />} />
          <Route path="/all-order-status" element={<AdminRoute element={<AllOrderStatus />} />} />
          <Route path="/product-status" element={<AdminRoute element={<ProductStatus />} />} />
          {/* purchasebill */}
          <Route path="/all-purchase-bill-merchants" element={<AdminRoute element={<AllPurchaseBillMerchants />} />} />
          <Route path="/all-purchase-bill" element={<AdminRoute element={<AllPurchaseBill />} />} />
          <Route path="/add-purchase-bill" element={<AdminRoute element={<AddPurchaseBill />} />} />

          {/* transaction */}
          <Route path="/all-transaction-merchant-name" element={<AdminRoute element={<AllTransactionsMerchantName />} />} />
          <Route path="/all-transaction" element={<AdminRoute element={<AllTransactions />} />} />
          <Route path="/add-transaction" element={<AdminRoute element={<AddTransaction/>} />} />

          {/* leads */} 
          <Route path="/all-lead" element={<AdminRoute element={<AllLead/>} />} />
          <Route path="/add-lead" element={<AdminRoute element={<AddLead/>} />} />
           <Route path="/all-lead-type" element={<AdminRoute element={<AllLeadType/>} />} /> 
            <Route path="/all-lead-status" element={<AdminRoute element={<AllLeadStatus/>} />} />
            <Route path="/all-lead-looking-for" element={<AdminRoute element={<AllLeadLookingFor/>} />} />
            <Route path="/all-lead-comments" element={<AdminRoute element={<LeadComments/>} />} />
          
          {/* Btobsales */}
             <Route path="/all-Btobsales-customers" element={<AdminRoute element={<AllBtobsalesCustomers/>} />} />
              <Route path="/all-Btobsales" element={<AdminRoute element={<AllBtobsales/>} />} />
               <Route path="/add-Btobsales" element={<AdminRoute element={<AddBtobsales/>} />} />

          <Route path="/Edit-order/:id" element={<AdminRoute element={<EditOrder />} />} />
          <Route path="/add-item/:orderId/:orderDate" element={<AdminRoute element={<AddItem />} />} />


          {/* common */}
          <Route path="/edit-profile" element={<ProtectedRoute element={<EditProfile />} />} />

          {/* vendor route */}
          <Route path="/all-vendor-product" element={<VendorRoute element={<AllVendorProducts />} />} />
          <Route path="/all-vendor-order" element={<VendorRoute element={<AllVendorOrder />} />} />
          <Route path="/vendor-dashboard" element={<VendorRoute element={<VendorDashboard />} />} />
          <Route path="/vendor-order/:id" element={<VendorRoute element={<ViewVendorOrder />} />} />
        </Routes>

      </div>
    </div>
  );
}

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <SidebarContext.Provider value={{ isCollapsed, setIsCollapsed }}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </SidebarContext.Provider>
  );
}

export default App;
